
import LoadSimple from "../LoadSimple";
import Modal from 'react-modal';
// import ModalDeleteGrupo from "./ModalDeleteGrupo";
import { useState, useEffect } from "react";
import { capitalizeFirstLetter } from "../../utils/utils";
import { lang } from "../generales/traduction";
import ModalHostList from "./ModalHostLis";
const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'30%',
    height:'20%',
    padding:'20px'
  },
};
const hostListModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "90%",
    padding: "20px",
  },
};
const GruposList = ({
  pageActual,
  startLimit,
  limitList,
  dataList,
  devices,
  handleChangEdit,
  setData,
  setRegisterIsValid,
  setLoading,
  setError,
  server,
  dataUsers,
  setDataUsers,
  searchResults,
  setSearchResults,
  searchTerm,
  setSearchTerm,
  cisSelected,
  setCisSelected,
  languaje,
  mode,
  rowSelected,
  poolRows,
  handleShowPopup,
  dataAnalisis
}) => {
  // const dataUsers=useFetch('cassia/ci','',localStorage.getItem('access_token'),'GET',server)

  // var dataList=(searchTerm==='')?dataUsers.data:searchResults;

  const [deleteUserModalOpen, setDeleteUserModalOpen] =useState(false);
  const [hostsListModalOpen, setHostsListModalOpen] =useState(false);
  const [userSelected,setUserSelected]=useState({})
  function openDeleteUserModal() {
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {
    setSearchTerm("")
    setDeleteUserModalOpen(false);
  }

  function openHostsListModal() {
    setHostsListModalOpen(true);
  }

  function closHostsListModal() {
    
    setHostsListModalOpen(false);
  }
  const handledeleteUserClick = (data) => {
        
    openDeleteUserModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  const [source,setSource]=useState('')
  const handleHostLisClick = (data,source) => {
    setSource(source)
    openHostsListModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  
 
  const cisSelectRow = (elemento) => {
    setCisSelected(elemento);
  };
 
  return (
    <>
      <div className="cont-row-user-list">
        {dataAnalisis.loading ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          dataList
            .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
            .map((elemento, indice) => (
              <div
                className={"row-table-portafolio"+mode}
                key={indice}
              >
                 
                <div className="field-body-table-mantenimiento field-larger">
                  {elemento.groupid}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{width:'17%'}}>
                  {elemento.group_name}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{width:'17%'}}>
                  {elemento.group_type}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{color:'var(--green-pastel)'}} >
                  {elemento.conectados}
                </div>
                <div className="field-body-table-mantenimiento field-larger fieldWFstatus"  style={{color:'var(--red-alert)'}}>
                <div style={{width:'35%'}} className="infoWFerror">
                  <img
                    src={
                      "/iconos/review.png"
                    } 
                    onClick={()=>handleHostLisClick(elemento,'disconnected_hosts')}
                    name="Ver"  title='Ver' className="btnAction delteException" style={{width:'65%'}}
                  />
                  </div>
                  {elemento.desconectados}
                </div>
                <div className="field-body-table-mantenimiento field-larger fieldWFstatus" >
                {
                    
                    <div style={{width:'35%'}} className="infoWFerror">
                  <img
                    src={
                      "/iconos/review.png"
                    } 
                    onClick={()=>handleHostLisClick(elemento,'unknown_hosts')}
                    name="Ver"  title='Ver' className="btnAction delteException" style={{width:'65%'}}
                  />
                  </div>
                }
                  {elemento.desconocidos}
                </div>
                <div className="field-body-table-mantenimiento field-larger" >
                  {elemento.conectados+elemento.desconectados+elemento.desconocidos}
                </div>
                
                
                
              </div>
            ))
        )}
        { dataList.length == 0 ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
        ) : (
          ""
        )}
      </div>
      <Modal
        isOpen={deleteUserModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          {/* <ModalDeleteGrupo handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} buscar_cis={buscar_cis} server={server} setData={setData} setLoading={setLoading} setError={setError} user={userSelected} closDeleteUserModal={closDeleteUserModal}></ModalDeleteGrupo> */}
    </Modal>
    <Modal
        isOpen={hostsListModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closHostsListModal}
        style={hostListModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalHostList  source ={source} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode}  server={server} setData={setData} setLoading={setLoading} setError={setError} brand={userSelected} closHostsListModal={closHostsListModal}></ModalHostList>
    </Modal>
    </>
  );
};

export default GruposList;
